import Loader from "../loader";

export const OutlineButton = (props) => {
  const {
    label,
    onClick,
    width = "w-96",
    icon,
    prefix = true,
    labelClass = "",
    loading,
  } = props || {};
  return (
    <div
      className={`h-11 ${width} rounded-lg items-center border border-solid border-gray-300 justify-center flex bg-white`}
    >
      {loading ? (
        <Loader />
      ) : (
        <button
          onClick={onClick}
          className={`${width} h-11 font-semibold text-base text-gray-700 ${labelClass} flex justify-center items-center`}
        >
          {!!icon && prefix && (
            <img src={icon} alt="" className="mr-2 w-4 h-4" />
          )}
          {label}
          {!!icon && !prefix && (
            <img src={icon} alt="" className="ml-2 w-4 h-4" />
          )}
        </button>
      )}
    </div>
  );
};
